import { useEffect, useRef, useState } from "react";
import App from "./App";
import { register } from "./funcStore";

export default function Pcsp() {
  // componentKey
  const COMPONENT_KEY = "PCSP"
  // state
  const STATE_BEFORE_INIT = "beforeInit";
  const PC = "pc";
  const SP = "sp";

  const [state, setState] = useState(STATE_BEFORE_INIT);
  const stateRef = useRef(state)
  stateRef.current = state

  // effect
  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      register(`${COMPONENT_KEY}.getState`,()=>stateRef.current)
      const nextState = window.innerWidth >= 768 ? PC : SP;

      setState(nextState);
    }
  }, [state]);

  return (
   <App />
  );
}